import { INSTAGRAM_CONTENT_TYPES, MEDIA_TYPES } from '~/constants';

import { Asset } from './asset.model';
import { Insight } from './content-insights.model';
import { CreatorType } from './creator';

export enum CONTENT_TYPE {
  Post = 'post',
  Story = 'story',
  Reels = 'reels',
}

export interface Content {
  '@context': string;
  '@id': string;
  '@type': string;
  id: string;
  creator: Pick<
    CreatorType,
    | 'createdAt'
    | 'createdAtAgo'
    | 'email'
    | 'id'
    | 'lastActivity'
    | 'lastLogin'
    | 'updatedAt'
    | 'updatedAtAgo'
  >;
  assets: Asset[];
  channel: INSTAGRAM_CONTENT_TYPES;
  contentType?: MEDIA_TYPES;
  insight: Insight;
  type: CONTENT_TYPE;
  thumbnails?: {
    medium: {
      url: string;
    };
  };
  followersCount: number;
  caption: string;
  permalink: string;
  postedAt: string;
  isBusinessAccountMedia: boolean;
  createdAt: string;
  updatedAt: string;
  shareLink: string;
  swipeUps: number;
  storyFollowersReachRate: number;
  engagements: number;
  stickerTaps: any[];
  shares: number;
  creatorId: string;
  postedAtAgo: string;
  createdAtAgo: string;
  updatedAtAgo: string;
  isPasswordProtected: boolean;
  impressions: number;
  reach: number;
  saved: number;
  likes: number;
  comments: number;
}

export interface PostContent extends Content {
  postFollowersEngRate?: number;
  postReachEngRate?: number;
  videoViews: number;
  videoReachViewRate: number;
}

export interface StoryContent extends Content {
  storyFollowersReachRate: number;
  replies: number;
  tapsForward: number;
  tapsBack: number;
  exits: number;
}

export interface ReelsContent extends Content {
  plays: number;
  igReelsAggregatedAllPlaysCount: number;
  interactions: number;
  postFollowersEngRate: number;
  postReachEngRate: number;
  videoReachViewRate: number;
}
